import React,{Component} from 'react'
import {Link} from 'react-router-dom';
import   './style.less';
import {withRouter} from "react-router-dom";
import { Menu, Icon } from 'antd';
const { SubMenu } = Menu;


class SideBar extends Component{
    state={
        selectKey:'questionbanksummary',
        openKey:'questionquantity'
    }
    componentWillMount(){
        if(this.props.location.pathname!=='http://127.0.0.1'){
            this.setState({
                selectKey:this.props.location.pathname.split("/")[2] || this.props.location.pathname.split("/")[1] || 'index',
                openKey:this.props.location.pathname.split("/")[1] || ''
            })
        }
    }
    render(){
        return (
            <div className="sideBarContainer">
               <Menu
                    mode="inline"
                    defaultSelectedKeys={[this.state.selectKey]}
                    defaultOpenKeys={[this.state.openKey]}
                    style={{ height: '100%', borderRight: 0 }}
                >
                    
                    <Menu.Item key={'index'}><Link to="/index"/><span><Icon type="home" />首页</span></Menu.Item>
                    <SubMenu key="questionquantity" title={<span><Icon type="switcher" />题量</span>}>
                        <Menu.Item key={'questiondetail'}><Link to="/questionquantity/questiondetail"/>题目详情</Menu.Item>
                        {/* <Menu.Item key={'questionbanktrend'}><Link to="/questionquantity/questionbanktrend"/>题库变化趋势</Menu.Item> */}
                        <Menu.Item key={'chapterCover'}><Link to="/questionquantity/chapterCover"/>章节覆盖度</Menu.Item>
                        <Menu.Item key={'pointCover'}><Link to="/questionquantity/pointCover"/>考点覆盖度</Menu.Item>
                        <Menu.Item key={'varietyData'}><Link to="/questionquantity/varietyData"/>多样性数据</Menu.Item>
                    </SubMenu>
                     <SubMenu key="user_data" title={<span><Icon type="line-chart" />用户数据</span>}>
                        <Menu.Item key={'assign_answer'}><Link to="/user_data/assign_answer"/>布置作答数据</Menu.Item>
                        <Menu.Item key={'task_distributed'}><Link to="/user_data/task_distributed"/>作业知识点分布</Menu.Item>
                    </SubMenu>
                </Menu>
            </div>
        )
    }
}
export default withRouter(SideBar);


// WEBPACK FOOTER //
// ./src/app/sidebar/view.js